export default {"src":"/_next/static/media/icon_info_i.3cb1f35d.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};